/*global _ */

/* DIS/PLAY Script
 Author's name: Dan Sørensen
 Modified by:
 Client name: ...
 Date of creation: ...
 */

var dis = dis || {};

(function (dis) {
	"use strict";


	dis.BaseModule.prototype.templating = function (str,args) {
		return str.replace(/{{(.*?)}}/g, function (m, g1) {
			var argValue = args[g1.trim()];
			if(argValue === undefined || argValue === "")
			{
				argValue = " ";
			}

			// for data-documentlistid this is a index of the documents in the list so this can be 0
			if(argValue === 0)
			{
				return argValue;
			}

			return argValue || m;
		});
	};


}(dis, _));